import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import FeedPageSideBar from "./Feed Page/custom-comp/FeedPageSideBar";
import NotificationPanel from "./Feed Page/custom-comp/NotificationPanel";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { CgMenuRight } from "react-icons/cg";


export default function HomeHeaderSidebar({
    userData,
    url,
    logo2,
    notif,
    setCreateLeadModel,
}) {
    const [showSideBar, setShowSideBar] = useState(false);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);


    const location = useLocation();

    const isHomeRoute = location.pathname === "/" || location.pathname === "/feed";

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (currentScrollY <= 0) {
                        // Always show at very top
                        setShowHeader(true);
                    } else if (currentScrollY > lastScrollY + 2 && currentScrollY > 50) {
                        // small buffer for down scroll
                        setShowHeader(false);
                    } else if (currentScrollY < lastScrollY - 2) {
                        // small buffer for up scroll
                        setShowHeader(true);
                    }

                    setLastScrollY(currentScrollY);
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);





    useEffect(() => {
        if (showSideBar) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
        return () => {
            document.body.classList.remove("no-scroll");
        };
    }, [showSideBar]);


    return (
        <div className="web-app-sidebar-section" style={{ top: showHeader ? "30px" : (window.innerWidth > 1024 ? "30px" : "-50px") }} >
            <div
                className={`live-reel-header-text-profile-section mobile-app-sidebar ${showHeader ? "show" : "hide"
                    }`}
            >
                <div className="live-reel-header-text">
                    {isHomeRoute ? (
                        <div
                            className="live-reel-header-image"
                            onClick={() => setCreateLeadModel(true)}
                        >
                            <img
                                src={
                                    userData?.img
                                        ? url + userData.img
                                        : "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_1280.png"
                                }
                                alt="user-profile"
                            />
                        </div>
                    ) : (
                        <Link to="/">
                            <div className="live-reel-header-image-partywitty-logo">
                                <img src={logo2} alt="partywitty-logo" />
                            </div>
                        </Link>
                    )}

                    {isHomeRoute ? (
                        <div
                            className="live-reel-header-text-content-input"
                            onClick={() => setCreateLeadModel(true)}
                        >
                            <input
                                type="search"
                                readOnly
                                placeholder={`What's on your mind ${userData?.name ? userData?.name : ""
                                    }?`}
                            />
                            <i className="in-mobile-view-only fi-rr-picture feed-profile-icon"></i>
                        </div>
                    ) : (
                        <>
                            <div className="live-reel-header-text-icon-section-notif-wrapper " >
                                <span className="live-reel-header-text-icon-mobile"><MdOutlineNotificationsActive /></span>
                            </div>
                        </>
                    )}

                    {/* Mobile burger menu */}
                    <div className="">
                        <span
                            className=" feed-profile-icon-mobile-burger live-reel-header-text-icon-mobile"
                            onClick={() => setShowSideBar(true)}
                        >    <CgMenuRight /></span>
                    </div>

                </div>

                {/* Quick action icons */}
                <div className="live-reel-header-text-icon-section">
                    <div
                        className="lrhtis-icons blue-image"
                        onClick={() => setCreateLeadModel(true)}
                    >
                        <i className="fi-rr-picture feed-profile-icon"></i>image
                    </div>
                    <div
                        className="lrhtis-icons green-image"
                        onClick={() => setCreateLeadModel(true)}
                    >
                        <i className="fi-br-video-camera-alt feed-profile-icon"></i>video
                    </div>
                    <div
                        className="lrhtis-icons voilet-image"
                        onClick={() => setCreateLeadModel(true)}
                    >
                        <i className="fi-rr-edit feed-profile-icon"></i>write text
                    </div>
                </div>
            </div>

            {/* Sidebar always visible in web */}

            {/* Sidebar drawer */}
            <div
                className={`feed-page-sidebar ${showSideBar ? "active" : ""}`}
            >
                <div className="feed-page-sidebar-content">
                    <FeedPageSideBar notif={notif} setShowSideBar={setShowSideBar} />
                </div>
            </div>
            {showSideBar && (
                <div
                    className="feed-page-sidebar-overlay"
                    onClick={() => setShowSideBar(false)}
                ></div>
            )}



            <div className="web-app-sidebar">
                <FeedPageSideBar />
            </div>

            <NotificationPanel
                isOpen={showNotificationPanel}
                onClose={() => setShowNotificationPanel(false)}
                notifications={notif}
            />
        </div>
    );
}
